// extracted by mini-css-extract-plugin
export default {"container":"AddCard_container__jAwOP","formContainer":"AddCard_formContainer__3Z0qM","CheckoutInfo":"AddCard_CheckoutInfo__vOkEv"};